var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-end"},[(_vm.isProfileLoaded)?_c('div',[_c('div',[_vm._v(_vm._s(_vm.profileDisplayName))]),_c('div',[_vm._v("Point "+_vm._s(_vm.points))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }